import { ChangeDetectionStrategy, Component, input } from '@angular/core'

import { ImageOptions, PublicationCardItem } from 'app/core/cms/generated/api-types'
import { createCmsLinkFromCardItem } from 'app/utils/create-cms-link-from-card-item.function'
import { explicitComputed } from 'app/utils/signal-utils'

import { AnchorCardComponent } from '../anchor-card/anchor-card.component'

@Component({
  selector: 'pai-publication-item-card',
  imports: [AnchorCardComponent],
  templateUrl: './publication-item-card.component.html',
  styleUrl: './publication-item-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicationItemCardComponent {
  readonly data = input.required<PublicationCardItem>()

  protected readonly imgOpts: ImageOptions = { objectFit: 'cover', ratio: '_5_3' }
  protected readonly target = explicitComputed(this.data, createCmsLinkFromCardItem)
  protected readonly date = explicitComputed(this.data, (item): Date | null =>
    item?.date ? new Date(item.date) : null,
  )
}
